import type {_ActionsTree} from 'pinia';
import type {LoadingStoreState} from "~/store/loading/state";

export interface LoadingStoreActions extends _ActionsTree {
    openLoading: (mode: string) => void;
    closeLoading: () => void;
}

export const actions: LoadingStoreActions | LoadingStoreState = {
    openLoading(mode: string): void {
        const that: LoadingStoreState = this as LoadingStoreState;
        that.show = true;
        that.mode = mode;
    },

    closeLoading(): void {
        const that: LoadingStoreState = this as LoadingStoreState;
        that.show = false;
    }
};
